<template>
  <vx-card>
    <div class="vs-con-loading__container" v-if="carregadoFull == false"></div>
    <div class="mt-5" v-if="dadosProposta != {}">
      <h3 class="flex gap-2 mb-6">
        Proposta
        {{
          `${dadosProposta.idProposta} - ${
            dadosProposta.idTipoApolice != TIPO_APOLICE.RCVAT ? 'AUTO' : 'RCVAT'
          } ${verificaEmpresaBemProtege(dadosProposta.idEmpresa) ? '-' : ''}`
        }}
        <div v-if="verificaEmpresaBemProtege(dadosProposta.idEmpresa)">
          <vs-chip
            :color="getStatusColor(dadosProposta.idStatus)"
            class="product-order-status"
          >
            {{ dadosProposta.nomeStatus }}
          </vs-chip>
        </div>
      </h3>
      <div
        v-if="!(resposavelVistoria || !statusAguardandoAprovacao)"
        class="vx-row mb-3"
      >
        <div v-if="dadosProposta.idTipoApolice != TIPO_APOLICE.RCVAT">
          <div class="vx-col w-full">
            <vs-alert style="height: auto" active="true" color="warning">
              Esta proposta está bloqueada para alterações pois está no status
              "{{ STATUS_PROPOSTA.AGUARDANDO_APROVACAO.name }}", somente o
              responsável pela análise pode fazer alterações.
            </vs-alert>
          </div>
        </div>
      </div>

      <div class="text-right" v-if="carregadoFull == true">
        <vs-button
          v-if="
            dadosProposta.idTipoApolice != TIPO_APOLICE.RCVAT &&
            dadosProposta.idStatus != STATUS_PROPOSTA.FINALIZADO.id &&
            dadosProposta.idStatus != STATUS_PROPOSTA.RECUSADA.id &&
            (resposavelVistoria || !statusAguardandoAprovacao)
          "
          color="success"
          type="gradient"
          class="mr-3 mb-2 w-full sm:w-auto"
          @click="openModalProdutos()"
          :disabled="questionarioPendente"
          >Buscar e Atualizar Produtos
        </vs-button>
        <vs-button
          v-if="
            dadosProposta.idTipoApolice == TIPO_APOLICE.RCVAT &&
            dadosProposta.idStatus != STATUS_PROPOSTA.FINALIZADO.id &&
            dadosProposta.idStatus != STATUS_PROPOSTA.RECUSADA.id &&
            (resposavelVistoria || !statusAguardandoAprovacao)
          "
          color="success"
          type="gradient"
          class="mr-3 mb-2 w-full sm:w-auto"
          @click="openModalProdutosRcvat()"
          :disabled="questionarioPendente"
          >Buscar e Atualizar Produtos RCVAT
        </vs-button>
        <vs-button
          v-if="dadosProposta.idStatus == STATUS_PROPOSTA.FINALIZADO.id"
          color="success"
          type="gradient"
          class="mr-3 mb-2 w-full sm:w-auto"
          @click="openModalProdutos()"
          :disabled="questionarioPendente"
          >Vizualizar Produtos
        </vs-button>

        <router-link :to="`/detalheVistoria/${dadosProposta.idProposta}`">
          <vs-button
            color="dark"
            type="gradient"
            class="mr-3 mb-2 w-full sm:w-auto"
          >
            <vs-icon icon="camera" class="mr-3"></vs-icon>
            Detalhe Proposta
          </vs-button>
        </router-link>

        <router-link
          target="_blank"
          :to="`/proposta/${dadosProposta.chave}?interno=true`"
        >
          <vs-button
            color="warning"
            type="gradient"
            class="mr-3 mb-2 w-full sm:w-auto"
          >
            <vs-icon icon="send" class="mr-3"></vs-icon>
            Visualizar Proposta
          </vs-button>
        </router-link>
        <vs-button
          v-if="$can('Exibir Historico Alteracoes', 'Cotações')"
          color="primary"
          type="gradient"
          class="mr-3 w-full sm:w-auto"
          @click="openModalLogs(dadosProposta)"
        >
          <vs-icon icon="list" class="mr-3"></vs-icon>
          Histórico de Alterações
        </vs-button>
        <vs-button
          @click="openModalHistoricoMensageria()"
          class="mr-3 mb-2 btn-print purple-btn"
          v-tooltip="'Histórico de mensageria'"
        >
          <vs-icon icon="email" class="mr-3"></vs-icon>
          Histórico de Mensageria
        </vs-button>
      </div>
      <form role="form" @submit.stop.prevent="onSubmit">
        <h3 class="mb-3 mt-6">Dados Gerais</h3>
        <hr class="mb-6" />
        <formDadosGerais
          :formulario.sync="form"
          :dadosProposta="dadosProposta"
          :regionais="regionais"
          :divisoes="divisoes"
          :colaboradoresCadastro="colaboradoresCadastro"
          :status="status"
          :consultores="consultores"
          :fotos="fotos"
          :dadosUsuario="dadosUsuario"
          @loaded.once="carregaFormPai"
          @changed="alteraFormPai"
        ></formDadosGerais>
        <h3 class="mb-3 mt-6">Dados do Cliente</h3>
        <hr class="mb-6" />
        <formDadosCliente
          :formulario="form"
          :dadosProposta="dadosProposta"
          :regionais="regionais"
          @loaded.once="carregaFormPai"
          @changed="alteraFormPai"
        ></formDadosCliente>
        <h3 class="mb-3 mt-6">Dados do Veículo</h3>
        <hr class="mb-6" />
        <formDadosVeiculo
          :quotationData="quotationData"
          :formulario="form"
          :dadosProposta="dadosProposta"
          :grupos="grupos"
          :combustiveis="listaCombustiveis"
          :cores="listaCores"
          :cidadeCliente="cidadeAux"
          :estadoCliente="estadoAux"
          :idUsuario="idUsuario"
          :permitePlacaRepetida="permiteVariasCotacoesPorPlaca"
          :questionarioPendente="questionarioPendente"
          @loaded.once="carregaFormPai"
          @changed="alteraFormPai"
          @salvar="onSubmit()"
          @permitSalvar="naoPermitirSalvarPlacaInvalida"
        ></formDadosVeiculo>
        <Modal
          id="meu-popup-personalizado"
          class="holamundo"
          :title="'Editar Produtos'"
          :active.sync="modalProdutos"
          @close="(modalProdutos = false), (precisaAlterarProduto = false)"
        >
          <h3 class="mb-6">Produtos</h3>
          <formDadosProduto
            :formulario="form"
            :dadosProposta="dadosProposta"
            :precisaAlterarProduto="precisaAlterarProduto"
            @loaded="carregaFormPai"
            @changed="alteraFormPai"
            @salvar="
              modalProdutos = false;
              precisaAlterarProduto = false;
              buscarAtualizarProds = true;
              onSubmit();
            "
          ></formDadosProduto>
        </Modal>
        <Modal
          id="meu-popup-personalizado"
          class="holamundo"
          :title="'Editar Produtos RCVAT'"
          :active.sync="modalProdutosRcvat"
          @close="(modalProdutosRcvat = false), (precisaAlterarProduto = false)"
        >
          <h3 class="mb-6">Produtos RCVAT</h3>
          <formProdutosRcvat
            :dadosProposta="dadosProposta"
            :quotationData="quotationData"
            :create="false"
            @salvarProdutosRcvat="salvarProdutosRcvat($event)"
          ></formProdutosRcvat>
        </Modal>

        <Modal
          fullscreen
          class="holamundo"
          :title="'Histórico de Alterações'"
          :active.sync="modalLogs"
          @close="resetModalLogs()"
        >
          <h3 class="mb-6">Proposta {{ this.dadosProposta.idProposta }}</h3>
          <vs-table
            class="tablePrincipal"
            noDataText="Sem Alterações"
            ref="table"
            stripe
            search
            :data="logsAlteracoes"
          >
            <template slot="thead">
              <vs-th sort-key="tabela" class="uppercase">Referência</vs-th>
              <vs-th sort-key="campo" class="uppercase">Campo</vs-th>
              <vs-th sort-key="dadoOld" class="uppercase">Dado anterior</vs-th>
              <vs-th sort-key="dadoNew" class="uppercase">Dado posterior</vs-th>
              <vs-th sort-key="user" class="uppercase"
                >Usuário da alteração
              </vs-th>
              <vs-th sort-key="createdAt" class="uppercase"
                >Data e Hora da Alteração
              </vs-th>
            </template>
            <template slot-scope="{ data }">
              <tbody>
                <vs-tr v-for="(item, index) in data" :key="index">
                  <vs-td class="product-tabela">
                    <p>{{ item.tabela }}</p>
                  </vs-td>
                  <vs-td class="product-campo">
                    <p
                      v-if="
                        [
                          'PropostasProdutosComplementos',
                          'propostasProdutos',
                        ].includes(item.tabela) &&
                        item.campo != 'produtoAdicionado' &&
                        item.campo != 'produtoDeletado'
                      "
                    >
                      {{ item.nomeProduto }}
                    </p>
                    <p class="font-bold">{{ item.campo }}</p>
                  </vs-td>

                  <vs-td class="product-dadoOld">
                    <div class="flex">
                      {{ item.dadoOld ? item.dadoOld : '-' }}
                      <p
                        v-if="
                          [
                            'PropostasProdutosComplementos',
                            'propostasProdutos',
                          ].includes(item.tabela) &&
                          item.campo == 'produtoDeletado'
                        "
                      >
                        -
                        {{ item.nomeProduto }}
                      </p>
                    </div>
                  </vs-td>

                  <vs-td class="product-dadoNew">
                    <div class="flex">
                      {{ item.dadoNew ? item.dadoNew : '-' }}
                      <p
                        v-if="
                          [
                            'PropostasProdutosComplementos',
                            'propostasProdutos',
                          ].includes(item.tabela) &&
                          item.campo == 'produtoAdicionado'
                        "
                      >
                        -
                        {{ item.nomeProduto }}
                      </p>
                    </div>
                  </vs-td>

                  <vs-td class="product-user"
                    >{{ item.user }} - {{ item.nomeUsuario }}
                  </vs-td>

                  <vs-td class="product-createdAt pl-6"
                    >{{ item.createdAt }}
                  </vs-td>
                </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </Modal>
        <h3 class="mb-3 mt-6">Dados Financeiros</h3>
        <hr class="mb-6" />
        <formDadosFinanceiro
          :dadosProposta="dadosProposta"
          :produtosSelecionados="form.dadosProduto.produtosSelecionados"
          :key="shouldRenderChild"
          @loaded.once="carregaFormPai"
          @changed="alteraFormPai"
        ></formDadosFinanceiro>

        <div v-if="dadosProposta.idTipoApolice != TIPO_APOLICE.RCVAT">
          <div
            v-if="!(resposavelVistoria || !statusAguardandoAprovacao)"
            class="vx-row mt-3"
          >
            <div class="vx-col w-full">
              <vs-alert style="height: auto" active="true" color="warning">
                Esta proposta esta bloqueada para alterações pois esta no status
                "{{ STATUS_PROPOSTA.AGUARDANDO_APROVACAO.name }}", somente o
                responsável pela vistoria pode fazer alterações.
              </vs-alert>
            </div>
          </div>
        </div>
        <div class="vx-row mt-3" v-if="carregadoFull == true">
          <div
            v-if="precisaAlterarProduto == false"
            class="vx-col w-full text-right"
          >
            <vs-button
              v-if="propostaNaoAceita"
              color="primary"
              type="gradient"
              class="mr-5"
              @click.stop.prevent="aceitarProposta"
              :disabled="desabilitarBotaoAceitarProposta"
            >
              Contratar e seguir para a Vistoria
            </vs-button>
            <BotaoSubmit
              v-if="
                semRetricao ||
                (dadosProposta.idStatus != STATUS_PROPOSTA.FINALIZADO.id &&
                  dadosProposta.idStatus != STATUS_PROPOSTA.RECUSADA.id &&
                  (resposavelVistoria || !statusAguardandoAprovacao))
              "
              variant="success"
              :edit="true"
              :aguarde="aguardeCadastro"
              :disabled="desabilitarbotaoSalvar"
            ></BotaoSubmit>
          </div>
        </div>
      </form>
    </div>
    <ModalHistoricoMensageria
      v-if="dadosProposta && dadosProposta.idApolice"
      :active.sync="modalHistoricoMensageria"
      :dadosProposta="dadosProposta"
      @close="closeMessagingModal()"
    />
  </vx-card>
</template>

<script>
const { TIPO_APOLICE } = require('../../../common/constant/tipo_apolice');
import { STATUS_PROPOSTA, URL_VISTORIA } from '../../utils/constants';

import jwt from 'jsonwebtoken';
import moment from 'moment';
import BotaoSubmit from '../../components/BotaoSubmit';
import Modal from '../../components/Modal.vue';
import cpfCnpj from '../../services/cpfCnpj';
import quotationApiService from '../../services/quotation-api';
import functions from '../../utils/functions';
import notify from '../../utils/notify';
import ModalHistoricoMensageria from '../modais/ModalHistoricoMensageria.vue';
import locale from './../../locale';
import service from './../../services';
import servicesLifeApi from './../../services/life-api';
import {
  obterDadosUsuarioLogado,
  verificaUsuarioAdmin,
} from './../../services/usuario';
import formProdutosRcvat from './../forms/formProdutosRcvat.vue';
import formDadosGerais from './../forms/formProposta_p0';
import formDadosCliente from './../forms/formProposta_p1';
import formDadosVeiculo from './../forms/formProposta_p2';
import formDadosProduto from './../forms/formProposta_p3';
import formDadosFinanceiro from './../forms/formProposta_p4';

export default {
  components: {
    BotaoSubmit,
    formDadosGerais,
    formDadosCliente,
    formDadosVeiculo,
    formDadosProduto,
    formProdutosRcvat,
    formDadosFinanceiro,
    ModalHistoricoMensageria,
    Modal,
  },
  watch: {
    precisaAlterarProduto: function (newValue) {
      if (newValue) {
        // this.openModalProdutos();
        this.notificar(this.textoMsgNotificacao, this.corMessagemNoticacao);
      }
    },
    aceiteUnificacao() {
      if (this.aceiteUnificacao) {
        this.onSubmit();
      }
    },
    'form.dadosVeiculo.agravos': {
      handler: function (newValeus, oldValues) {
        const agravosValidos = this.verificarAgravos();

        if (!agravosValidos) {
          this.questionarioPendente = true;
        } else {
          this.questionarioPendente = false;
        }

        if (agravosValidos && oldValues !== null && oldValues !== undefined) {
          this.dadosProposta.agravos = this.form.dadosVeiculo.agravos;
          this.openModalProdutos();
        }
      },
      deep: true,
    },
    questionarioPendente(newValues, oldValues) {
      if (!newValues && oldValues) {
        this.dadosProposta.agravos = this.form.dadosVeiculo.agravos;
        this.openModalProdutos();
      }
    },
  },
  computed: {
    semRetricao() {
      return this.$can('Edição sem Restrição', 'Cotações');
    },
    resposavelVistoria() {
      const { idResponsavel } = this.dadosProposta;
      return idResponsavel === this.idUsuario;
    },
    statusAguardandoAprovacao() {
      const { nomeStatus, idStatus } = this.dadosProposta;
      return (
        nomeStatus === STATUS_PROPOSTA.AGUARDANDO_APROVACAO.name &&
        idStatus === STATUS_PROPOSTA.AGUARDANDO_APROVACAO.id
      );
    },
    propostaNaoAceita() {
      const { dataAceite, idStatus } = this.dadosProposta;
      return idStatus !== STATUS_PROPOSTA.RECUSADA.id && !dataAceite
        ? true
        : false;
    },
    desabilitarbotaoSalvar() {
      return this.habilitaDesabilitaBtnSalvar || this.questionarioPendente;
    },
    desabilitarBotaoAceitarProposta() {
      return this.questionarioPendente || this.aceitarPropostaPendente;
    },
  },
  data() {
    return {
      TIPO_APOLICE,
      STATUS_PROPOSTA,
      dadosUsuario: null,
      dadosProposta: {},
      cachedInsuredData: null,
      cachedVehicleData: null,
      quotationData: {},
      msg: null,
      mensal: 0,
      shouldRenderChild: 0,
      buscarAtualizarProds: false,
      cidadeAux: null,
      estadoAux: null,
      idEmpresa: null,
      idUsuario: null,
      textoMsgNotificacao: null,
      corMessagemNoticacao: 'sucesso',
      openCollapseDadosGerais: true,
      openCollapseDadosCliente: true,
      openCollapseDadosVeiculo: true,
      modalProdutos: false,
      modalProdutosRcvat: false,
      aguardeCadastro: false,
      precisaAlterarProduto: false,
      regionais: [],
      divisoes: [],
      consultores: [],
      colaboradoresCadastro: [],
      status: [],
      grupos: [],
      listaCores: [],
      listaCombustiveis: [],
      fotos: [],
      form: {
        dadosGerais: {},
        dadosCliente: {},
        dadosVeiculo: {},
        dadosProduto: {},
        dadosFinaneiros: {},
      },
      passo: 0,
      carregadoFull: true,
      modalLogs: false,
      logsAlteracoes: [],
      aceiteUnificacao: null,
      formUnificacao: {},
      permiteVariasCotacoesPorPlaca: false,
      codigoSituacaoPlaca: 0,
      habilitaDesabilitaBtnSalvar: false,
      questionarioPendente: false,
      aceitarPropostaPendente: false,
      modalHistoricoMensageria: false,
    };
  },
  methods: {
    closeMessagingModal() {
      this.modalHistoricoMensageria = false;
    },
    salvarProdutosRcvat(quotation) {
      this.modalProdutosRcvat = false;
      this.precisaAlterarProduto = false;
      this.quotationData = quotation;
      this.$vs.notify({
        position: 'top-center',
        title: 'Atenção',
        text: `Produtos atualizados com sucesso`,
        color: 'success',
      });
    },
    forceRenderChild() {
      this.shouldRenderChild++;
    },
    openModalHistoricoMensageria() {
      this.modalHistoricoMensageria = true;
    },
    notificar(text, corNotificacao, tempoExibirNotificacao) {
      const mensagem =
        text || `Os dados da proposta foram alterados, revise os produtos`;
      const color = corNotificacao || 'success';
      const time = tempoExibirNotificacao || 4000;

      this.$vs.notify({
        position: 'top-center',
        title: 'Atenção',
        text: mensagem,
        color,
        time,
      });

      this.textoMsgNotificacao = null;
      this.corMessagemNoticacao = null;
    },
    validaFormasPagamentoProdutos() {
      this.msg = '';
      this.mensal = 0;

      this.form.dadosProduto.produtosSelecionados.forEach((produto) => {
        if (
          (produto.isMensal || produto.ismensal) &&
          !produto.idTipoPagamentoEmpresa
        ) {
          this.mensal = this.mensal + 1;
        }
      });

      this.mensal > 0
        ? (this.msg =
            this.msg + 'Selecione a Forma de Pagamento Mensal' + '<br><br>')
        : '';

      this.form.dadosProduto.produtosSelecionados.forEach((produto) => {
        if (
          (produto.isMensal == false || produto.ismensal == false) &&
          !produto.idTipoPagamentoEmpresa
        ) {
          this.msg =
            this.msg +
            'Selecione a Forma de Pagamento do item ' +
            produto.nomeProduto +
            '<br><br>';
        }
      });

      !this.dadosProposta.diaVencimentoMensalidade
        ? (this.msg = this.msg + 'Selecione um Dia de Vencimento Mensal')
        : '';
    },
    verificaFormasPagamento(array, key) {
      let count = 0;
      for (let i = 0; i < array.length; i++) {
        if (
          array[i] &&
          array[i].hasOwnProperty(key) &&
          array[i][key] !== null
        ) {
          count;
        } else {
          count += 1;
        }
      }
      return count;
    },
    async onSubmit() {
      const [...errosValidacao] = this.$validator.errors.items;
      this.preencheProdutosSelecionadosFinanceiroOnSubmit();
      // let verificaPgs = 0;
      // verificaPgs = this.verificaFormasPagamento(
      //   this.form.dadosProduto.produtosSelecionados,
      //   'idTipoPagamentoEmpresa',
      // );

      if (
        this.form.dadosVeiculo.valorFipe == 0 &&
        !this.form.dadosVeiculo.somenteAgregado
      ) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Preço FIPE ou Valor de cobertura zerado',
          color: 'danger',
        });
      } else {
        this.form.dadosProposta = this.dadosProposta;

        const chassiInvalido = errosValidacao.find(
          (item) => item.field == 'Chassi',
        );

        if (chassiInvalido) {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: chassiInvalido.msg,
            color: 'danger',
          });
          return;
        }

        if (
          this.form.dadosVeiculo.placa ===
            this.form.dadosVeiculo.placaSubstituicao &&
          this.form.tipoProposta == 'Substituição'
        ) {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Placas de entrada e saída não podem ser iguais',
            color: 'danger',
          });
          return;
        }
        this.ajustaKm();

        if (this.form.dadosCliente.cpfcnpj) {
          if (
            cpfCnpj.valida_cpf_cnpj(this.form.dadosCliente.cpfcnpj) == false
          ) {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: `Este CPF ou CNPJ não é válido`,
              color: 'danger',
            });
            return;
          }
        }

        this.aguardeCadastro = true;
        this.$vs.loading();

        const atualizaPropostaGeral = service.post(
          'Cotacao',
          'AtualizarPropostaGeral',
          this.form,
        );

        const atualizaTabelaProposta = this.dadosProposta
          .diaVencimentoMensalidade
          ? await service.post('Grupo', 'atualiza-tabela-proposta', {
              idProposta: this.form.dadosProposta.idProposta,
              diaVencimentoMensalidade:
                this.dadosProposta.diaVencimentoMensalidade,
            })
          : Promise.resolve(); // Se não houver diaVencimentoMensalidade, resolve a Promise imediatamente

        Promise.all([atualizaPropostaGeral, atualizaTabelaProposta])
          .then(() => {
            this.aguardeCadastro = false;
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: `Operação Realizada com sucesso`,
              color: 'success',
            });

            this.$emit('concluido');

            this.$vs.loading.close();
            this.aguardeCadastro = false;
            this.aceitarPropostaPendente = false;

            setTimeout(() => this.recarregaPagina(), 2000);
          })
          .catch((error) => {
            this.aguardeCadastro = false;
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: error,
              color: 'danger',
            });
          });
      }

      this.buscarAtualizarProds = false;
    },
    recarregaFormFinanceiro() {
      this.$emit('recarregaFinanceiro');
    },
    carregaFormPai({ formulario, ...data }) {
      this.form[formulario] = data;
    },
    alteraFormPai({ formulario, id, value }) {
      if (this.form.dadosCliente.unificaAssociado) {
        this.aceiteUnificacao = this.form.dadosCliente.unificaAssociado;
      }
      this.form[formulario][id] = value;
      if (id === 'tipoProposta') {
        this.dadosProposta.tipoProposta = this.form.dadosGerais.tipoProposta;
      }

      this.validaAlteracaoProduto({ id, value });
    },
    validaAlteracaoProduto(obj) {
      const { id, value } = obj;
      let _precisaAlterarProduto = false;

      const formFiltroStorage = localStorage.getItem('formFiltro');
      const formFiltro =
        formFiltroStorage !== null ? JSON.parse(formFiltroStorage) : {};
      const formFiltroVazio = this._isObjectEmpty(formFiltro);

      const { tipoProposta, restricoes, valorNf } = this.dadosProposta;

      const { cidade, estado } = this.dadosProposta.dadosCliente;

      const { cilindradas, valorCobertura } = this.dadosProposta.dadosVeiculo;

      const {
        tipoProposta: tipoPropostaFormFiltro,
        cidade: cidadeFormFiltro,
        estado: estadoFormFiltro,
      } = formFiltro;

      let existeDiferecaRestricoes = null;
      let temResultFipeVazio = null;
      let preco = null;

      switch (id) {
        case 'tipoProposta':
          _precisaAlterarProduto =
            value !== tipoProposta ? true : _precisaAlterarProduto;

          if (!formFiltroVazio)
            _precisaAlterarProduto =
              value !== tipoPropostaFormFiltro ? true : _precisaAlterarProduto;

          if (_precisaAlterarProduto) this.openModalProdutos();
          break;
        case 'restricoesSelecionadas':
          const arrIdsRestricoesProposta = restricoes.reduce(
            (acc, { idRestricao }) => {
              acc.push(idRestricao);
              return acc;
            },
            [],
          );

          existeDiferecaRestricoes =
            JSON.stringify(value) !== JSON.stringify(arrIdsRestricoesProposta);

          _precisaAlterarProduto = existeDiferecaRestricoes
            ? true
            : _precisaAlterarProduto;

          if (_precisaAlterarProduto) this.openModalProdutos();
          break;
        case 'valorNf': //com bug não permite fechar o modal de produtos
          if (valorNf == null && value == '0,00')
            return (_precisaAlterarProduto = false);

          const isStringformValorNf = typeof value === 'string' && value;

          if (isStringformValorNf) {
            const valorNfFormatado = parseFloat(
              value.replace('.', '').replace(',', '.'),
            );
            const exiteDiferencaValorNf = valorNfFormatado !== valorNf;

            _precisaAlterarProduto = exiteDiferencaValorNf
              ? true
              : _precisaAlterarProduto;
          }

          if (_precisaAlterarProduto) this.openModalProdutos();
          break;
        case 'cidade':
          _precisaAlterarProduto =
            value !== cidade ? true : _precisaAlterarProduto;

          if (!formFiltroVazio)
            _precisaAlterarProduto =
              value !== cidadeFormFiltro ? true : _precisaAlterarProduto;

          this.cidadeAux = value;
          if (_precisaAlterarProduto) this.openModalProdutos();
          break;
        case 'estado':
          _precisaAlterarProduto =
            value !== estado ? true : _precisaAlterarProduto;

          if (!formFiltroVazio)
            _precisaAlterarProduto =
              value !== estadoFormFiltro ? true : _precisaAlterarProduto;

          this.estadoAux = value;
          if (_precisaAlterarProduto) this.openModalProdutos();
          break;
        case 'fipeAtualizada':
          this.form.dadosVeiculo.veiculo.resultFipe = null;
          this.form.dadosVeiculo.veiculo.resultFipe =
            this.form.dadosVeiculo.fipeAtualizada;

          temResultFipeVazio = this._isObjectEmpty(value);
          preco = !temResultFipeVazio ? value.preco : 0;

          _precisaAlterarProduto = preco ? true : _precisaAlterarProduto;

          if (!formFiltroVazio) {
            const temFormFiltroValor = formFiltro.hasOwnProperty('valor')
              ? true
              : false;

            if (temFormFiltroValor && !temResultFipeVazio)
              _precisaAlterarProduto =
                preco !== formFiltro.valor ? true : _precisaAlterarProduto;
          }

          this.textoMsgNotificacao = 'FIPE Atualizada revise os produtos';
          this.corMessagemNoticacao = 'warning';

          if (_precisaAlterarProduto) {
            this.openModalProdutos();
          }
          break;
        case 'cilindradas':
          const temDiferencaCilindradas = value !== cilindradas;
          _precisaAlterarProduto = temDiferencaCilindradas
            ? true
            : _precisaAlterarProduto;

          if (!formFiltroVazio) {
            const temFormFiltroCilindradas = formFiltro.hasOwnProperty(
              'cilindradas',
            )
              ? true
              : false;

            if (temFormFiltroCilindradas)
              _precisaAlterarProduto =
                value !== formFiltro.cilindradas
                  ? true
                  : _precisaAlterarProduto;
          }

          if (_precisaAlterarProduto) this.openModalProdutos();
          break;
        case 'valorCobertura':
          _precisaAlterarProduto =
            valorCobertura !== value ? true : _precisaAlterarProduto;

          if (_precisaAlterarProduto) this.openModalProdutos();
          break;
        default:
          break;
      }
    },
    buscaDados() {
      return new Promise((resolve, reject) => {
        var objSend = {};

        objSend.idProposta = this.$route.params.idCotacao;
        objSend.qtdPorPagina = this.itemsPerPage;
        objSend.idEmpresa = this.idEmpresa;
        if (objSend.idProposta) {
          service
            .post('Cotacao', 'listarCotacoes', objSend)
            .then(async (res) => {
              if (res.data.length > 0) {
                const dadosProposta = res.data[0];

                try {
                  if (!this.cachedInsuredData || !this.cachedVehicleData) {
                    const [clienteRes, veiculoRes] = await Promise.all([
                      service.post('Cotacao', 'listInsuredData', objSend),
                      service.post('Cotacao', 'listVehicleData', objSend),
                    ]);
                    this.cachedInsuredData = clienteRes.data;
                    this.cachedVehicleData = veiculoRes.data;
                  }
                  if (this.cachedInsuredData && dadosProposta.dadosCliente) {
                    Object.assign(
                      dadosProposta.dadosCliente,
                      this.cachedInsuredData,
                    );
                  }
                  if (this.cachedVehicleData && dadosProposta.dadosVeiculo) {
                    Object.assign(
                      dadosProposta.dadosVeiculo,
                      this.cachedVehicleData,
                    );
                  }
                } catch (mergeError) {
                  console.error(mergeError);
                }

                this.dadosProposta = dadosProposta;
                await this.buscaCoresECombustivel();
                if (this.dadosProposta.idTipoApolice == TIPO_APOLICE.RCVAT) {
                  this.quotationData =
                    await quotationApiService.getRcvatQuotation(
                      objSend.idProposta,
                    );
                }
                this.preencheProdutosSelecionadosFinanceiro();

                resolve();
              } else {
                this.$vs.notify({
                  position: 'top-center',
                  title: 'Atenção',
                  text: 'Você não tem acesso a visualização desta Proposta/Vistoria',
                  color: 'danger',
                });
                resolve();
              }
            })
            .catch((e) => {
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: e,
                color: 'danger',
              });
              reject();
            });
        }
      });
    },
    preencheProdutosSelecionadosFinanceiro() {
      this.form.dadosProduto.produtosSelecionados.forEach(async (produto) => {
        const produtoEncontrado = this.dadosProposta.produtos.find(
          (findProd) =>
            (produto.id_produto || produto.idProduto) === findProd.idProduto,
        );
        if (produtoEncontrado) {
          Object.assign(produto, {
            idTipoPagamentoEmpresa: produtoEncontrado.idTipoPagamentoEmpresa,
            nomePagamento: produtoEncontrado.nomePagamento,
          });
        }
      });
    },
    preencheProdutosSelecionadosFinanceiroOnSubmit() {
      this.form.dadosProduto.produtosSelecionados.forEach(async (produto) => {
        const produtoEncontrado = this.dadosProposta.produtos.find(
          (findProd) =>
            (produto.id_produto || produto.idProduto) === findProd.idProduto,
        );
        if (produtoEncontrado) {
          if (
            !produto.idTipoPagamentoEmpresa &&
            produtoEncontrado.idTipoPagamentoEmpresa
          ) {
            Object.assign(produto, {
              idTipoPagamentoEmpresa: produtoEncontrado.idTipoPagamentoEmpresa,
              nomePagamento: produtoEncontrado.nomePagamento,
            });
          }
        }
      });
    },
    buscaDadosSelectsPorEmpresa(model, array, campoDescricao, campoPK) {
      return new Promise((resolve) => {
        service
          .getAll(
            'g',
            {},
            `${model}/list/idEmpresa/idEmpresa=${this.idEmpresa}`,
          )
          .then((res) => {
            this[array].push({ label: 'Selecione', id: null });
            res.data.forEach((element) => {
              element.id = element[campoPK];
              element.label = element[campoDescricao];
              this[array].push(element);
            });
            resolve();
          });
      });
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      return new Promise((resolve) => {
        service.getAll('g', {}, `${model}/list/`).then((res) => {
          res.data.forEach((element) => {
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
          });
          resolve();
        });
      });
    },
    buscaFotosPorProposta() {
      return new Promise((resolve) => {
        var objSend = {};
        objSend.idProposta = this.$route.params.idCotacao;
        objSend.idEmpresa = this.dadosProposta.idEmpresa;
        objSend.idGrupo = this.dadosProposta.idGrupo;
        objSend.idTipoFipe = this.dadosProposta.dadosVeiculo.codTipoVeiculo;

        service
          .post('Cotacao', 'listarFotosCotacao', objSend)
          .then((res) => {
            res.data.forEach((element) => {
              var aux = this.fotos.filter((x) => x.id == element.id_modeloFoto);
              if (aux.length == 0)
                this.fotos.push({
                  id: element.id_modeloFoto,
                  label: element.nomePosicao,
                });
            });
            this.isMounted = true;
            resolve();
          })
          .catch((e) => {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: e,
              color: 'danger',
            });
            resolve();
          });
      });
    },
    buscaCoresECombustivel() {
      return new Promise((resolve) => {
        service
          .post('Cotacao', 'listarCoresECombustivel', {
            idRegional: this.dadosProposta.idRegional,
            idProposta: this.$route.params.idCotacao,
          })
          .then((res) => {
            this.listaCores.push({ label: 'Selecione', id: null });
            this.listaCombustiveis.push({ label: 'Selecione', id: null });

            res.data.cores.forEach((element) => {
              this.listaCores.push({
                label: element.descricao,
                id: element.descricao,
              });
            });

            res.data.combustiveis.forEach((element) => {
              this.listaCombustiveis.push({
                label: element.descricao,
                id: element.descricao,
              });
            });
            resolve();
          });
      });
    },
    async buscaColaboradoresDoCadastro() {
      const idSetorCadastro = await this.buscarIdDoSetorCadastro();
      service
        .post('Usuario', 'buscarUsuario', {
          idEmpresa: this.idEmpresa,
          idSetor: idSetorCadastro.id,
        })
        .then((res) => {
          this.colaboradoresCadastro = res.data.map((colaborador) => {
            return {
              id: colaborador.idUsuario,
              label: colaborador.nome,
            };
          });
          this.colaboradoresCadastro.unshift({ label: 'Selecione', id: null });
        })
        .catch(() => {});
    },
    buscarIdDoSetorCadastro() {
      return new Promise((resolve, reject) => {
        service
          .post('Setor', 'buscar-id-setor-por-nome', {
            idEmpresa: this.idEmpresa,
            nomeSetor: 'cadastro',
          })
          .then((res) => {
            resolve(res.data);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    openModalProdutos() {
      const agravosInvalidos = !this.verificarAgravos();
      if (agravosInvalidos) {
        return;
      }

      this.modalProdutos = true;
      this.precisaAlterarProduto = true;
    },
    openModalProdutosRcvat() {
      const agravosInvalidos = !this.verificarAgravos();
      if (agravosInvalidos) {
        return;
      }

      this.modalProdutosRcvat = true;
      this.precisaAlterarProduto = true;
    },
    _isObjectEmpty(value) {
      const isEmpty =
        value && Object.keys(value).length && value.constructor === Object;

      return !isEmpty;
    },
    _isObject(value) {
      const isObject =
        typeof value === 'object' && !Array.isArray(value) && value !== null;

      return isObject;
    },
    async carregarFull() {
      this.$vs.loading();
      await this.buscaDados();
      await this.buscaDadosSelects(
        'domStatusCotacao',
        'status',
        'nomeStatus',
        'idStatus',
      );
      await this.buscaDadosSelectsPorEmpresa(
        'regionais',
        'regionais',
        'nome',
        'idRegional',
      );
      await this.buscaDadosSelectsPorEmpresa(
        'divisoes',
        'divisoes',
        'nomeDivisao',
        'idDivisao',
      );
      await this.buscaDadosSelectsPorEmpresa(
        'usuarios',
        'consultores',
        'nome',
        'idUsuario',
      );
      await this.buscaDadosSelectsPorEmpresa(
        'gruposVeiculos',
        'grupos',
        'nomeGrupo',
        'idGrupo',
      );
      await this.buscaColaboradoresDoCadastro();

      await this.buscaDadosUsuario();

      this.cidadeAux =
        this.form.dadosCliente.cidade || this.dadosProposta.dadosCliente.cidade;
      this.estadoAux =
        this.form.dadosCliente.estado || this.dadosProposta.dadosCliente.estado;
      this.carregadoFull = true;
      this.$vs.loading.close();
    },
    decoded() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.decoded = jwt.decode(token);
        this.idUsuario = this.decoded.id_usuario;
        this.idEmpresa = this.decoded.id_empresa;
      }
    },
    ajustaKm() {
      const _km = Number(this.form.dadosVeiculo.km);
      this.form.dadosVeiculo.km = !_km ? 1 : Number(this.form.dadosVeiculo.km);
    },
    openModalLogs(obj) {
      this.$vs.loading();
      this.modalLogs = true;
      if (obj.idProposta)
        service
          .post('Cotacao', 'buscaLogsProposta', {
            idProposta: obj.idProposta,
            idAssociado: obj.dadosCliente.idProspect,
          })
          .then((res) => {
            res.data.map((item) => {
              if (parseInt(item.dadoOld) === parseInt(item.dadoNew)) return;
              if (
                item.dadoOld &&
                !isNaN(item.dadoOld) &&
                item.dadoOld.includes('.')
              ) {
                item.dadoOld = Number(item.dadoOld).toFixed(2);
              }
              if (
                item.dadoNew &&
                !isNaN(item.dadoNew) &&
                item.dadoNew.includes('.')
              ) {
                item.dadoNew = Number(item.dadoNew).toFixed(2);
              }
              if (
                item.campo.split('- ')[1] == 'descontoConcedido' ||
                item.campo == 'valorCotaParticipacao'
              ) {
                item.dadoOld = `${item.dadoOld} %`;
                item.dadoNew = `${item.dadoNew} %`;
              }
              if (
                ['valorFinal', 'valor'].includes(item.campo.split('- ')[1]) ||
                [
                  'valorCobertura',
                  'valorParticipacaoMinimo',
                  'valorFipe',
                ].includes(item.campo)
              ) {
                item.dadoOld = `R$ ${item.dadoOld}`;
                item.dadoNew = `R$ ${item.dadoNew}`;
              }
              if (
                ['dataNascimento', 'dataVencimentoCnh'].includes(item.campo)
              ) {
                item.dadoOld = moment(item.dadoOld).utc().format('DD/MM/YYYY');
                item.dadoNew = moment(item.dadoNew).utc().format('DD/MM/YYYY');
              }
              if (
                [
                  'idUsuario',
                  'idUsuarioResponsavelVistoria',
                  'idStatus',
                ].includes(item.campo)
              ) {
                item.dadoNew = item.novo_dadoNew;
                item.dadoOld = item.novo_dadoOld;
              }
              if (item.tabela == 'PropostasComplementos') {
                item.tabela = item.novo_dadoNew;
              }

              item.createdAt = moment(item.createdAt)
                .utc()
                .format('DD/MM/YYYY - HH:mm');
              this.logsAlteracoes.push(item);
            });
            this.$vs.loading.close();
          });
    },
    resetModalLogs() {
      this.logsAlteracoes = [];
    },
    async buscaDadosUsuario() {
      try {
        const { data } = await obterDadosUsuarioLogado(
          this.idEmpresa,
          this.idUsuario,
        );
        const [dadosUsuario] = data;

        const superUser = verificaUsuarioAdmin();
        this.dadosUsuario = { ...dadosUsuario, superUser };
      } catch (error) {
        this.$vs.loading.close();
      }
    },
    getStatusColor(data) {
      return functions.getStatusColor(data);
    },
    verificaEmpresaBemProtege(idEmpresa) {
      return functions.verificaEmpresaBemProtege(idEmpresa);
    },
    async buscaDadosEmpresa() {
      const res = await service.getAll(
        'g',
        {},
        'empresas/list/idEmpresa/' + this.idEmpresa,
      );

      const [data] = res.data;

      const { permiteVariasCotacoesPorPlaca } = data;
      this.permiteVariasCotacoesPorPlaca = permiteVariasCotacoesPorPlaca;
    },
    naoPermitirSalvarPlacaInvalida(codigoSituacaoPlaca) {
      this.codigoSituacaoPlaca = codigoSituacaoPlaca;

      if (this.codigoSituacaoPlaca == 999) {
        this.habilitaDesabilitaBtnSalvar = true;
      }

      if (this.codigoSituacaoPlaca == 0) {
        this.habilitaDesabilitaBtnSalvar = false;
      }

      return;
    },
    recarregaPagina() {
      window.location.reload(true);
    },

    // SEGURADORA
    async aceitarProposta() {
      try {
        const { dadosCliente, dadosFinaneiros } = this.form;

        const { idTipoPagamento, qtdParcelas, diaVencimentoMensalidade } =
          dadosFinaneiros;

        const dados = {
          tipoPessoa: dadosCliente.tipo,
          cpfcnpj: dadosCliente.cpfcnpj,
          nome: dadosCliente.nome,
          email: dadosCliente.email,
          celular: dadosCliente.celular,
          cep: dadosCliente.cep,
          endereco: dadosCliente.endereco,
          numero: dadosCliente.numero,
          bairro: dadosCliente.bairro,
          cidade: dadosCliente.cidade,
          estado: dadosCliente.estado,
          canaisComunicacao: ['WhatsApp', 'Email', 'SMS'],
          idCotacao: dadosCliente.idProposta,
          ['Dia de Vencimento']: diaVencimentoMensalidade,
          ['Forma de Pagamento']: idTipoPagamento,
          ['Quantidade de parcelas']: qtdParcelas,
        };

        let dadosValidados = true;

        Object.entries(dados).forEach((p) => {
          const [prop, valor] = p;

          if (valor === null || valor === undefined) {
            notify.notifyFail(
              this.$vs,
              `Por favor preencha o campo ${prop} e salve as alterações!`,
            );
            dadosValidados = false;

            this.aceitarPropostaPendente = true;
          }
        });

        if (dadosValidados) {
          this.$vs.loading();

          const { data } = await service.post(
            'CotacaoAberta',
            'aceiteProposta',
            dados,
          );

          if (data.success) {
            notify.notifySuccess(
              this.$vs,
              'Proposta aceita com sucesso!, Por favor prossiga com a vistoria.',
            );

            const controller = 'prior-inspections';
            const body = {
              proposal_id: this.dadosProposta.idProposta,
              key: this.dadosProposta.chave,
            };
            await servicesLifeApi.post(controller, body);

            this.redirectVistoriaV2();
          }

          notify.notifyFail(this.$vs, data.error);
        }

        return Promise.resolve();
      } catch (error) {
        notify.notifyFail(this.$vs, error);
        return Promise.reject(error);
      } finally {
        this.$vs.loading.close();
      }
    },
    redirectVistoriaV2() {
      const link = `${URL_VISTORIA}/${this.dadosProposta.chave}`;
      window.open(link, '_blank');
    },
    verificarAgravos() {
      let agravosValidos = true;
      for (const agravo of this.form.dadosVeiculo.agravos) {
        const [[, resposta]] = Object.entries(agravo);
        if (!resposta) {
          agravosValidos = false;
          break;
        }
      }
      return agravosValidos;
    },
  },
  async created() {
    this.decoded();
    await this.buscaDadosEmpresa();
  },
  async mounted() {
    this.$validator.localize('ptBr', locale);
    localStorage.removeItem('formFiltro');
    await this.carregarFull();
  },
};
</script>

<style>
.vs-chip-bg-pink {
  background-color: rgb(255, 68, 0);
}

.vs-chip-bg-blue {
  background-color: navy;
}

.vdp-datepicker input {
  width: 100%;
}

#meu-popup-personalizado.con-vs-popup .vs-popup {
  width: 60%;
}

@media (max-width: 870px) {
  #meu-popup-personalizado.con-vs-popup .vs-popup {
    min-width: 95%;
  }
}
</style>
<style scoped lang="scss">
.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;

  tr td {
    padding: 2px;
  }

  tr:nth-child(2n) {
    background: #efefef !important;
  }
}

.vs-radio--circle {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  -webkit-transition: all 0.25s ease;
  transition: all 0.25s ease;
  top: 0;
  background-color: #d8e2ff !important;
}

.purple-btn {
  background-color: #7b49e7 !important;
}
</style>
